/*
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-26 15:52:06
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-10-26 17:03:02
 * @FilePath: /chaoyongtuan/src/utils/newDataMap/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

//-------------------商品库本地字典---------------
import SHOP_MANAGE from './shopManage';

export default {
	SHOP_MANAGE,
};
